import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { UserPoolsDropdownFieldComponent } from '../../../fields/standard/user-pools-dropdown-field/user-pools-dropdown-field.component';

@Component({
	selector: 'app-client-user-export-form',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, UserPoolsDropdownFieldComponent],
	templateUrl: './client-user-export-form.component.html',
	styleUrl: './client-user-export-form.component.scss',
})
export class ClientUserExportFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup = this.fb.group({
		userPoolId: ['', TextFieldComponent.validators],
	});

	constructor(private fb: FormBuilder) {}

	public onSubmit() {
		this.onSubmitEmitter.emit(this.form.value);
	}
}
